export interface ParsedEmailDateHeader {
  rawLine?: string;
  /** Normalized offset label, e.g. +08:00, or a named zone in parentheses */
  offsetLabel?: string;
}

/** Extract Date: header line and timezone hint from stored raw headers. */
export function parseEmailDateHeader(messageHeaders?: string | null): ParsedEmailDateHeader {
  if (!messageHeaders?.trim()) return {};
  const match = messageHeaders.match(/^Date:\s*(.+)$/im);
  if (!match) return {};
  const rawLine = match[1].trim();
  const offsetLabel = extractDateHeaderOffset(rawLine);
  return { rawLine, offsetLabel };
}

function extractDateHeaderOffset(rawLine: string): string | undefined {
  const numeric = rawLine.match(/\s([+-])(\d{2})(?::?(\d{2}))?\s*$/);
  if (numeric) {
    const minutes = numeric[3] ?? '00';
    return `${numeric[1]}${numeric[2]}:${minutes}`;
  }
  if (/\bUTC\b/i.test(rawLine)) return 'UTC';
  if (/\bGMT\b/i.test(rawLine)) return 'GMT';
  const named = rawLine.match(/\(([^)]+)\)\s*$/);
  if (named?.[1]) return named[1].trim();
  return undefined;
}
